import { NavBarComponent as NavBar } from "./navBar.component";
export default NavBar;
